<div [ngClass]="{ 'template-dialog': isTemplateGrid }">
  <div class="select-channel-dialog">
    <div
      class="chips-parent"
      [ngClass]="{ 'flex-parent': channels.length > 3 }"
    >
      <div
        *ngFor="let channel of channels"
        (click)="channelSelected(channel)"
        class="chips"
        [ngClass]="{ 'flex-more': channels.length > 3 }"
        (keyDown)="$event.preventDefault()"
      >
        <div>
          <div class="img" *ngIf="channel.icon">
            <img
              src="{{ channel.icon }}"
              class="icons-img"
              [alt]="channel.label"
            />
          </div>
          <div>{{ channel.label }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
